export const passRecoveryEnLocale = {
  'pass-recovery.title': 'Reset password',
  'pass-recovery.description':
    'Enter your email address and we will send you instructions to reset your password.',
  'pass-recovery.entry.user': 'Enter yout email',
  'pass-recovery.validation.email.email': 'Please enter a valid email address.',
  'pass-recovery.validation.email.min': 'Please enter an email address.',
  'pass-recovery.buttom.submit': 'Reset password',
  'pass-recovery.loading': 'Sending recovery email...',
  'pass-recovery.success':
    'We have sent you an email to reset your password. Please check your inbox.',
} as const;

export const passRecoveryEsLocale = {
  'pass-recovery.title': 'Restablecer la contraseña',
  'pass-recovery.description':
    'Ingresa tu correo y te enviaremos instrucciones para restablecer tu contraseña.',
  'pass-recovery.entry.user': 'Ingresa tu correo',
  'pass-recovery.validation.email.email': 'Por favor ingresa un correo válido.',
  'pass-recovery.validation.email.min': 'Por favor ingresa un correo.',
  'pass-recovery.buttom.submit': 'Restablecer contraseña',
  'pass-recovery.loading': 'Enviando email de recuperación...',
  'pass-recovery.success':
    'Te hemos enviado un correo para restablecer tu contraseña. Por favor revisa tu bandeja de entrada.',
} as const;
